import angular from 'angular';
import uiRouter from 'angular-ui-router';
import navigationComponent from './navigation.component';
import navigationService from './navigation.service';
import emittentenService from '../forms/emittenten/emittenten.service';

let navigationModule = angular.module('navigation', [
  uiRouter
])

.component('navigation', navigationComponent)
.service('navigationService', navigationService)

.name;

export default navigationModule;



// WEBPACK FOOTER //
// ./client/app/common/navigation/navigation.js